module.exports = __webpack_public_path__ + "img/Evidencing Outcomes.f0d7d888.png";